import React from 'react';
import {useSelector} from 'react-redux';
import CountdownTimer from '../CountdownTimer';

interface AdfsCountdownInfoProps {
    expireTime?: Date | null;
    className?: string;
    onExpire?: () => void;
}

interface AdfsCountdownRootState {
    authorization: {expireTime: Date | null};
}

const AdfsCountdownInfo = ({expireTime, className, onExpire}: AdfsCountdownInfoProps): JSX.Element | null => {
    const cachedExpiry = useSelector((state: AdfsCountdownRootState) => state.authorization.expireTime);
    const deadline = expireTime ?? cachedExpiry;

    return deadline instanceof Date && Number.isFinite(deadline.getTime())
        ? <CountdownTimer expireTime={deadline} className={className} onExpire={onExpire}/>
        : null;
};

export default AdfsCountdownInfo;
